import React, { memo, useEffect } from 'react';
import { submit } from 'redux-form';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { GroupFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import {
  EXISTING_ACCOUNT_RADIO_NO_OPTION,
  EXISTING_ACCOUNT_RADIO_YES_OPTION
} from 'constants/general';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { validationMessageError } from './constants';
import { setContentSquare } from 'utils/setContentSquare';

const haveWeMetBeforeRadioItems = [
  {
    id: 'radio-account-existing',
    labelText: 'Yes'
  },
  { id: 'radio-account-ntb', labelText: `No` }
];

const getSelectedIDFromValue = (value) => {
  if (value === EXISTING_ACCOUNT_RADIO_YES_OPTION) {
    return 'radio-account-existing';
  }
  if (value === EXISTING_ACCOUNT_RADIO_NO_OPTION) {
    return 'radio-account-ntb';
  }
};

const mapRadioIDToValue = (id) => {
  if (id === 'radio-account-existing') {
    return EXISTING_ACCOUNT_RADIO_YES_OPTION;
  }
  if (id === 'radio-account-ntb') {
    return EXISTING_ACCOUNT_RADIO_NO_OPTION;
  }
};

const HomeScreen = memo(function HomeScreen({ handleSubmit, change, accountValue, isLoading }) {
  /*resume scenario application navigate to root screen and able to see as background.
  Hence check is there to hide content of screen
  Debt - Need to find alternate to remove this condition.
  */

  const dispatch = useDispatch();
  const hasSelectedRadioButton = getSelectedIDFromValue(accountValue) ? true : false;
  const [displayValidationMessage, setDisplayValidationMessage] = useState(false);
  useEffect(() => {
    setContentSquare();
  }, []);

  if (isLoading) return null;
  return (
    <form onSubmit={handleSubmit}>
      <PageHeading id={'homeScreenHeader'}>{`Have we met before?`}</PageHeading>
      <StandardBody>
        <p>{`With the exception of credit cards, have you ever had a Virgin Money, Clydesdale Bank or Yorkshire Bank product?`}</p>
      </StandardBody>
      <GroupFieldWrapper
        inputId={'radio-relationship-type'}
        name="account_header"
        titleText={''}
        validationMessage={
          !hasSelectedRadioButton && displayValidationMessage && validationMessageError
        }
      >
        <GenericRadio.StackedSet
          groupName="radio-relationship-type"
          items={haveWeMetBeforeRadioItems}
          onChange={(selectedId) => change('account', mapRadioIDToValue(selectedId))}
          selectedId={getSelectedIDFromValue(accountValue)}
          data-test-id="existing-account-checkboxes"
        />
      </GroupFieldWrapper>
      <StandardBody>
        <p>
          {accountValue
            ? accountValue === EXISTING_ACCOUNT_RADIO_NO_OPTION
              ? `It’s good to see you. Let’s get started.`
              : `Grab your online banking details and sign in to apply.`
            : ''}
        </p>
      </StandardBody>
      <NavigationButton.Primary
        labelText="Continue"
        onClick={() =>
          hasSelectedRadioButton ? dispatch(submit('Home')) : setDisplayValidationMessage(true)
        }
      />
    </form>
  );
});

export { HomeScreen };
